import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "rep_token";
export const isAdmin = (u) => !!u && (u.role === "admin" || u.role === "super_admin");

export const PREVIEW_KEY = "rep_preview";
export const PREVIEW_BLOCKED = "Disabled in preview";

export const readPreview = () => {
  try {
    return JSON.parse(sessionStorage.getItem(PREVIEW_KEY));
  } catch {
    return null;
  }
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const pv = readPreview();
  if (pv && window.location.pathname.startsWith("/portal") && !config.url.startsWith("/auth/me")) config.headers["X-Preview-As"] = pv.id;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config.url.includes("/auth/login")) {
      localStorage.removeItem(TOKEN_KEY);
      if (window.location.pathname !== "/login") window.location.assign("/login");
    }
    return Promise.reject(err);
  },
);

export function apiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return { message: err?.message || "Something went wrong. Please try again.", fields: {} };
  if (typeof detail === "string") return { message: detail, fields: {} };
  if (Array.isArray(detail)) {
    const fields = {};
    detail.forEach((e) => {
      const key = Array.isArray(e?.loc) ? e.loc[e.loc.length - 1] : null;
      if (key) fields[key] = e.msg;
    });
    return { message: detail.map((e) => e?.msg).filter(Boolean).join(" "), fields };
  }
  return { message: detail.message || "Something went wrong.", fields: detail.fields || {} };
}
